import { render, staticRenderFns } from "./myFooter.vue?vue&type=template&id=18b3059d&scoped=true"
import script from "./myFooter.vue?vue&type=script&lang=js"
export * from "./myFooter.vue?vue&type=script&lang=js"
import style0 from "./myFooter.vue?vue&type=style&index=0&id=18b3059d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b3059d",
  null
  
)

export default component.exports